export default "__VITE_ASSET__cc70dc66__"